import roundToNearest from './roundToNearest';

/**
 * Returns a locale formatted string representation of `listingsCount`.
 * @param listingsCount The number to format.
 * @param rounded Optionally round the number down in multiples of hundreds or thousands.
 */
const getTotalListings = (
  listingsCount: number,
  rounded: boolean = false,
): string => {
  const nearest = listingsCount > 1000 ? 1000 : 100;
  return rounded && listingsCount > 100
    ? `${roundToNearest(listingsCount, nearest).toLocaleString()}+`
    : listingsCount.toLocaleString();
};

export default getTotalListings;
